import ArchivedProductsList from './ArchivedProductsList'

export default ArchivedProductsList
